import { MoveSection } from '../types';
import { call, select } from 'redux-saga/effects';
import { MultipleOpinionScaleQuesState } from '../../../../../shared/types/QuesTypes';
import { putEffect } from '../../../../../shared/utils/putEffect';
import { setSurveyError } from '../../shared/actions';
import { setQuestion } from '../../sharedQuestions/actions';
import { move } from 'ramda';
import { set, updateAll } from 'shades';
import axios from '@utils/axios';
import { getApiEndPointUrl } from '../../../../../shared/utils/getApiEndpointUrl';
import { questionSectionsEndPoint } from '../consts';
import { processMultipleOpinionScaleSectionsResponse } from '../../surveyInfo/sagas/utils';
import { getApiError } from '../../../../../shared/utils/getApiError';

export function* reorderSections(action: MoveSection) {
	const { quesId, srcIndex, destIndex } = action.payload;
	const { questions } = yield select((s) => s.surveyBuilder);
	if (!!questions[quesId]) {
		const question: MultipleOpinionScaleQuesState = questions[quesId];

		try {
			// Performing reorder before API confirmation for smooth UX
			yield putEffect(
				setQuestion(
					question.id,
					set('settings', 'sectionOrder')(move(srcIndex, destIndex, question.settings.sectionOrder))(question),
					true
				)
			);

			const { data } = yield call(
				axios.patch,
				getApiEndPointUrl(questionSectionsEndPoint, question.settings.sectionOrder[srcIndex]),
				{
					questionId: question.id,
					orderPosition: destIndex + 1,
				}
			);

			const { sections, sectionsOrder } = processMultipleOpinionScaleSectionsResponse(data);

			yield putEffect(
				setQuestion(
					question.id,
					updateAll<MultipleOpinionScaleQuesState>(
						set('sections')(sections),
						set('settings', 'sectionOrder')(sectionsOrder)
					)(question)
				)
			);
		} catch (e) {
			// reverting change if API request fails
			yield putEffect(setQuestion(question.id, question));
			yield putEffect(setSurveyError(getApiError(e)));
		}
	} else {
		let question: any;
		for (const questionId in questions) {
			const section = questions[questionId];
			if (section?.metaData && section?.questionnaireId.length > 0) {
				if (section?.questions?.[quesId]) {
					question = section?.questions?.[quesId];
					break;
				}
			}
		}
		try {
			// Performing reorder before API confirmation for smooth UX
			yield putEffect(
				setQuestion(
					question.id,
					set('settings', 'sectionOrder')(move(srcIndex, destIndex, question.settings.sectionOrder))(question),
					true
				)
			);

			const { data } = yield call(
				axios.patch,
				getApiEndPointUrl(questionSectionsEndPoint, question.settings.sectionOrder[srcIndex]),
				{
					questionId: question.id,
					orderPosition: destIndex + 1,
				}
			);

			const { sections, sectionsOrder } = processMultipleOpinionScaleSectionsResponse(data);

			questions[question?.questionnaireSectionId].questions[question.id] = setQuestion(
				question.id,
				updateAll<MultipleOpinionScaleQuesState>(
					set('sections')(sections),
					set('settings', 'sectionOrder')(sectionsOrder)
				)(question)
			);

			yield putEffect(setQuestion(question?.questionnaireSectionId, questions[question?.questionnaireSectionId]));
		} catch (e) {
			// reverting change if API request fails
			yield putEffect(setQuestion(question.id, question));
			yield putEffect(setSurveyError(getApiError(e)));
		}
	}
}
